// extracted by mini-css-extract-plugin
export var label = "_sc-0";
export var link = "_sc-1";